import { create } from 'zustand'

import type { QueryStore } from '@models/Query'

import { initialState } from '../services/searchGebiedswissels'
import type { GebiedswisselsSearch } from '../types/GebiedswisselsSearch'

export { useGebiedswisselsSearchStore }

const useGebiedswisselsSearchStore = () => {
  const query = useStore((state) => state.query)
  const storeQuery = useStore((state) => state.storeQuery)

  return { query, storeQuery }
}

const useStore = create<QueryStore<GebiedswisselsSearch['query']>>((set) => ({
  query: initialState.query,
  storeQuery: (query) =>
    set((state) => ({ query: { ...state.query, ...query } })),
}))
